import apiClient from './apiClient';
import { ReleaseNoteVersion, DeployedVersion } from '../types/ReleaseNote';

export const releaseNotesApi = {
  /**
   * Get all release notes grouped by version (newest first).
   */
  getGrouped: async (): Promise<ReleaseNoteVersion[]> => {
    const response = await apiClient.get<ReleaseNoteVersion[]>('/api/releasenotes');
    return response.data;
  },

  /**
   * Get the currently deployed version per environment.
   */
  getDeployedVersions: async (): Promise<DeployedVersion[]> => {
    const response = await apiClient.get<DeployedVersion[]>('/api/releasenotes/deployed-version');
    return response.data;
  },

  /**
   * Get the full deploy history (all rows), newest first.
   */
  getDeployedVersionHistory: async (): Promise<DeployedVersion[]> => {
    const response = await apiClient.get<DeployedVersion[]>('/api/releasenotes/deployed-version/history');
    return response.data;
  }
};

export default releaseNotesApi;
